import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {DatatableComponent, DataTableDataSource, WorkType, WorkTypeService} from '@cas-hub/acabim-common-client';
import {DatePipe} from '@angular/common';
import {CategoryTableData} from '../work-order.model';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {WorkOrderCategoriesDataSource} from '../classes/work-category-data-source.class';

@Component({
  selector: 'acabim-admin-work-order-category-management',
  templateUrl: './work-order-category-management.component.html',
  styleUrls: ['../styles.scss', './work-order-category-management.component.scss']
})
export class WorkOrderCategoryManagementComponent implements OnInit {
  @ViewChild('categoryDataTable') public dataTable!: DatatableComponent;

  @Input() set workTypeDetails(value: any) {
    if (value) {
      this.workType = value;
      this.getData(value.id);
    }
  }
  @Output() completed = new EventEmitter<any>();
  @Output() cancelled = new EventEmitter<any>();

  addWorkCategory = false;
  dataTableSources: DataTableDataSource<any>[] = [];
  isLoading = false;
  loadDetails = false;
  nullDate: Date = new Date('0001-01-01T00:00:00');
  selectedDetails: CategoryTableData | null = null;
  workType: WorkType | null = null;
  columns: {field: string, header: string, class?: string}[] = [
    {header: 'Name', field: 'name'},
    {header: 'Default priority', field: 'default_priority_display', class: 'cas-priority-column'},
    {header: 'Last Modified', field: 'last_modified_display', class: 'cas-last-modified-column'},
    {header: 'Status', field: 'status_display', class: 'cas-status-column'}
  ];

  constructor(
      private readonly datePipe: DatePipe,
      private readonly workTypeService: WorkTypeService
  ) { }

  ngOnInit(): void {}

  getData(workTypeId: number): void {
      this.dataTableSources[0] = new WorkOrderCategoriesDataSource(
        'workCategory',
        this.dataRefresher(workTypeId),
        undefined,
        undefined,
        action => {}
      );
      if (this.dataTable) {
        this.dataTable.requestImmediateDataRefresh();
      }
  }

  private dataRefresher(workTypeId: number): () => Observable<CategoryTableData[]> {
    return () => {
      if (this.workType?.id) {
        return this.workTypeService.getCategories(this.workType?.id, {}).pipe(map(data => {
          return data.map(d => {
            const lmAsDate = d.last_modified ? new Date(d.last_modified) : null;
            const lmDate = lmAsDate && lmAsDate > this.nullDate ? this.datePipe.transform(lmAsDate, 'dd/MM/yyyy') as string : null;
            const out: CategoryTableData = {
              ...d,
              cbi_class_display: d.cbi_class ? d.cbi_class.id + ' – ' + d.cbi_class.name : '',
              default_priority_display: this.getDefaultPriorityString(d.default_priority),
              status_display: d.status === 1 ? 'Active' : 'Inactive',
              last_modified_display: lmDate
            }
            return out as CategoryTableData;
          });
        }));
      }
      return new Observable<CategoryTableData[]>();
    };
  }

  getDefaultPriorityString(value: number): string {
    let final = '';
    switch (value){
      case 1:
        final = 'Medium';
        break;
      case 2:
        final = 'High';
        break;
      default:
        final = 'Low'
    }
    return final;
  }

  getDefaultPriorityStringReversed(value: string): number {
    let final = 0;
    switch (value){
      case 'Medium':
        final = 1;
        break;
      case 'High':
        final = 2;
        break;
      default:
        final = 0
    }
    return final;
  }
  showDetails(rowData: any): void {
    this.loadDetails = true;
    // this.selectedDetails = rowData;
  }

  add(): void {
    this.addWorkCategory = true;
  }

  cancel(): void {
    this.cancelled.emit(false);
  }

  closeDetailsModal(value: any) {
    console.dir(value);
    this.loadDetails = value;
  }

  closeAddModal(value: any) {
    this.addWorkCategory = value;
  }

  completeDetailsModal(value: any) {
    if (value && this.workType && this.workType.id) {
      this.dataTable.requestImmediateDataRefresh();
    }
    this.addWorkCategory = false;
    this.loadDetails = false;
  }

  completeAddModal(value: any) {
    if (value && this.workType && this.workType.id) {
      this.dataTable.requestImmediateDataRefresh();
    }
    this.addWorkCategory = false;
  }

  setSelectedDetails(value: any) {
    this.selectedDetails = value;
  }

} // end of class

